export default __webpack_public_path__ + "static/media/card-3.8dc33041.webp";